import BaseService from '../../BaseService.js';

export default class FooterService extends BaseService {

  constructor() {
    super('version')
  }
}
